import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorDialogData } from './error-dialog.model';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent {
  now = new Date();

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data?: ErrorDialogData) {
  }

  getFullErrorMessage(): string {
    const parts: string[] = [];

    if (this.data?.errorType) {
      parts.push(`Typ: ${this.data.errorType}`);
    }

    parts.push(`Zeitpunkt: ${this.now.toISOString()}`);

    if (this.data?.requestId) {
      parts.push(`Request-ID: ${this.data.requestId}`);
    }

    if (this.data?.errorText) {
      parts.push(`Details: ${this.data.errorText}`);
    }

    return parts.join('\n');
  }
}
